import { render, staticRenderFns } from "./consent-box.vue?vue&type=template&id=57e70834&scoped=true&"
import script from "./consent-box.vue?vue&type=script&lang=js&"
export * from "./consent-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e70834",
  null
  
)

export default component.exports